<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'

    import { fly } from 'svelte/transition'

    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1"

    let y_value;

    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }

    import { nightmode } from "../stores5"
</script>

<div class:night={$nightmode} style="padding-left:8px;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: 200}}"></div>
        <div class="catch-item2" class:catch-item2-night={$nightmode} transition:fly="{{x: -200}}">お問い合わせ</div>
    </div>
    <div style="margin-left:2%; font-size:20px;">---preparing/準備中---</div>
    <footer class="footer" transition:fly="{{x: -200}}">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>

{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}

<svelte:window bind:scrollY={y_value}/>

<style>
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin-top:16px;
    margin-bottom:16px;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    position:relative;
    width:100%;
    height:580px;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    top:20px;
    right:-15px;
    width:80%;
    height:500px;
    background-image: url(/img/kinensai-pic-5.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 16% 50%;
    filter: saturate(0%);
    border-radius: 20px;
}
.catch-item2{
    display:table;
    background-color: greenyellow;
    position:absolute;
    top:500px;
    left:2%;
    font-size:40px;
    letter-spacing:.05em;
}
.catch-item2-night{
    color:#222831;
}
.footer{
    padding:40px 10px 40px 2%;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
</style>